import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { FileSelectorViewModel, ServerSideDataLoader } from "uicomponents";
import { AvailablePricingProcessSelectorViewModel, SetProductPriceViewModel, singleProductPrice } from "./setProductPrice-viewModel"

export class SetProductPriceView extends View<SetProductPriceViewModel>{
    GetViewUniqueId(): string {
        return "V-43FFE3CD-EED9-45D6-B973-08F08BE1F481"
    }
    loadHtml(): string {
        let element = require('./setProductPrice.html').default;
        let style = require('./setProductPrice.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set pricingProcessSelector(v: AvailablePricingProcessSelectorViewModel) { this._pricingProcessSelector = v; } public get pricingProcessSelector(): AvailablePricingProcessSelectorViewModel { return this._pricingProcessSelector;} private _pricingProcessSelector: AvailablePricingProcessSelectorViewModel;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set prices(v: ObservableArray<singleProductPrice>) { this._prices = v; } public get prices(): ObservableArray<singleProductPrice> { return this._prices;} private _prices: ObservableArray<singleProductPrice>;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
 
    import() {
        this.dataContext.import();
    }
    
    export() {
        this.dataContext.export();
    }
}
